/**
 * Access to the customer app is binary (MIL-419): a user may stay signed in only while the
 * user, their lab account and — for a business or insurance user — their customer account are all active.
 * Anything else, including a state that has not loaded, means no access.
 *
 * The router guard signs the user out when this returns true. Kept as a pure function so the
 * decision can be tested without a router, and so "what counts as disabled" has one definition.
 */

type TStateHolder = { activeState?: string } | null | undefined

export function isAccessDisabled({
  user,
  labAccount,
  customerAccount,
}: {
  user: (TStateHolder & { type?: string }) | null | undefined
  labAccount: TStateHolder
  customerAccount: TStateHolder
}): boolean {
  if (user?.activeState !== 'active') return true
  if (labAccount?.activeState !== 'active') return true

  // Business and insurance users belong to a customer account (a business customer or an insurance
  // customer — the account store loads whichever it is); a private user has none to check.
  const belongsToCustomerAccount =
    user.type === 'lab-customer-user-business' || user.type === 'lab-customer-user-insurance'
  if (belongsToCustomerAccount && customerAccount?.activeState !== 'active') {
    return true
  }

  return false
}
